import React from 'react';
import Icon from '../../components/Icon';

const defaultScholarship = {
  name: '',
  awardType: 'FIXED_AMOUNT',
  awAmountMin: undefined,
  awAmountMax: undefined,
  renewable: true,
  gpaMin: undefined,
  gpaMax: undefined,
  gpaRankMatch: 'OR',
  classRankMin: 0,
  classRankMax: 0,
  satGpaMatch: 'AND',
  satMin: undefined,
  satMax: undefined,
  satActMatch: 'OR',
  actMin: undefined,
  actMax: undefined,
  audience: 'ALL',
  audienceStates: [],
};

const numericFields = [
  'awAmountMin',
  'awAmountMax',
  'gpaMin',
  'gpaMax',
  'classRankMin',
  'classRankMax',
  'satMin',
  'satMax',
  'actMin',
  'actMax',
];

const classRankOptions = [
  { text: 'N/A', value: 0 },
  { text: 'Top 5%', value: 5 },
  { text: 'Top 10%', value: 10 },
  { text: 'Top 15%', value: 15 },
  { text: 'Top 20%', value: 20 },
  { text: 'Top 25%', value: 25 },
  { text: 'Top 30%', value: 30 },
  { text: 'Top 35%', value: 35 },
  { text: 'Top 40%', value: 40 },
  { text: 'Top 45%', value: 45 },
  { text: 'Top 50%', value: 50 },
  { text: 'Top 55%', value: 55 },
  { text: 'Top 60%', value: 60 },
  { text: 'Top 65%', value: 65 },
  { text: 'Top 70%', value: 70 },
  { text: 'Top 75%', value: 75 },
  { text: 'Top 80%', value: 80 },
  { text: 'Top 85%', value: 85 },
  { text: 'Top 90%', value: 90 },
  { text: 'Top 95%', value: 95 },
];

const chevronIcon = (<Icon name="chevron down" />);

export {
  numericFields,
  defaultScholarship,
  classRankOptions,
  chevronIcon,
};
